import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import { ENV_DEV } from './environment';

function init({ environment }) {
  if (environment === ENV_DEV) {
    return;
  }

  Sentry.init({
    environment,
    dsn:
      'https://a67ebebda80f4962bd9e2bde98bedd41@o565989.ingest.sentry.io/5708175',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

export default { init };
